import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// import styles
import './delivery.scss'

// Actions
import { getDeliveryInformation, saveDeliveryInformation } from '../../../actions/settings'
import { getShopCustomerAgreement, getPriceList } from '../../../actions/priceModel'

// Components
// import HelpText from '../../../shared/components/HelpText'

// Utils
import { translation, enumtranslate } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

import Panel from '../../../shared/elements/panel'
import PanelHeader from '../../../shared/elements/panelHeader'
import Text from '../../../shared/elements/text'
import Check from '../../../shared/elements/check'
import DropDown from '../../../shared/elements/dropDown'
import Inline from '../../../shared/elements/inline'
import Radio from '../../../shared/elements/radio'
import TableRow from '../../../shared/elements/tableRow'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import HelpIcon from '../../../shared/elements/helpIcon'
import Col from '../../../shared/elements/col'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import Label from '../../../shared/elements/label'

class Delivery extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Delivery: {
        CustomerId: 0,
        ShopId: 0,
        PriceModelId: props.agreementId !== undefined && props.agreementId !== null ? props.agreementId : 0,
        AllowChangeDelivery: false,
        LogDateChanges: false,
        UseDefaultDelivery: true,
        DefaultHours: 0,
        DeliveryPlusDriving: false,
        DeliveryHourPrices: []
      },
      NewItem: {
        Id: 0,
        PriceFrom: 0,
        PriceTo: 0,
        Hours: 1,
        PlusDriving: false,
        IsDeleted: false,
        ApplyType: 0
      },
      isShop: props.isShop === true,
      isAgreement: props.isAgreement === true,
      isMainAgreement: props.isMainAgreement === true,
      isLoaded: false,
      price: props.isAgreement === true ? (props.agreementPrice !== undefined ? props.agreementPrice : {}) : {},
      isLoading: false // To prevent double clicking on add, resulting in creation of duplicates
    }
    this.setItemToDelivery = this.setItemToDelivery.bind(this)
  }
  resetCreate () {
    this.setState({
      Delivery: {
        CustomerId: 0,
        ShopId: 0,
        PriceModelId: this.props.agreementId !== undefined && this.props.agreementId !== null ? this.props.agreementId : 0,
        AllowChangeDelivery: false,
        LogDateChanges: false,
        UseDefaultDelivery: true,
        DefaultHours: 0,
        DeliveryPlusDriving: false,
        DeliveryHourPrices: []
      },
      NewItem: {
        Id: 0,
        PriceFrom: 0,
        PriceTo: 0,
        Hours: 1,
        PlusDriving: false,
        IsDeleted: false,
        ApplyType: 0
      },
      price: this.props.isAgreement === true ? (this.props.agreementPrice !== undefined ? this.props.agreementPrice : {}) : {},
      isShop: this.props.isShop === true,
      isAgreement: this.props.isAgreement === true,
      isMainAgreement: this.props.isMainAgreement === true,
      isLoaded: false
    })
  }
  setItemToDelivery () {
    if (!this.state.isAgreement && this.state.isShop) {
      this.setState({
        Delivery: this.props.item,
        NewItem: {
          Id: 0,
          PriceFrom: 0,
          PriceTo: 0,
          Hours: 1,
          PlusDriving: false,
          IsDeleted: false,
          ApplyType: 0
        },
        price: {},
        isShop: this.props.isShop === true,
        isAgreement: this.props.isAgreement === true,
        isMainAgreement: this.props.isMainAgreement === true,
        isLoaded: false
      })
    }
  }
  componentDidMount () {
    this.getData()
  }

  getData () {
    this.setItemToDelivery()
    if (!this.state.isAgreement && !this.state.isShop && !this.state.isMainAgreement) {
      this.getDeliveryInformation(this.props)
    } else if (this.state.isAgreement && !this.state.isShop) {
      if (this.props.agreementPrice === undefined || this.props.agreementPrice.PriceModelId === undefined) {
        this.getCustomerAgreement(this.props.agreementId, this.props.selectedCustomerId, this.props.selectedShopId)
      } else {
        this.getPriceModelDeliveryInformation(this.props.agreementPrice.PriceModelId)
      }
    } else if (this.state.isShop || this.state.isMainAgreement) {
      let id = this.props.agreementId
      if (this.state.isShop) this.getDeliveryInformation(this.props)
      if (this.state.isMainAgreement) {
        this.getPriceModelDeliveryInformation(this.state.Delivery.PriceModelId)
        id = this.state.Delivery.PriceModelId
      }
      this.props.getPriceList(id).then((res) => {
        this.setState({
          price: res.data
        }, () => { this.updateApplyType() })
      }, () => {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
      })
    }
  }

  getCustomerAgreement (agreementId, customerId, companyId) {
    // console.log('getCustomerAgreement', agreementId, customerId)
    this.resetCreate()
    this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then((res) => {
      let { Delivery } = { ...this.state }
      if (!this.state.isShop) Delivery.PriceModelId = res.data.PriceModelId
      this.setState({
        price: res.data,
        Delivery: Delivery,
        isLoaded: true
      }, () => {
        if (!this.state.isShop) {
          this.getPriceModelDeliveryInformation(this.state.price.PriceModelId)
        } else {
          this.getPriceModelDeliveryInformation(this.state.Delivery.PriceModelId)
        }
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!this.state.isShop && !this.state.isAgreement && (this.props.agreementPrice === undefined || nextProps.agreementPrice === undefined || nextProps.params === undefined || nextProps.params.type === undefined || !isEqual(nextProps.params.type, this.props.params.type))) {
      this.getDeliveryInformation(nextProps)
      return
    }
    if (this.props.agreementPrice !== undefined && nextProps.agreementPrice !== undefined && !isEqual(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId)) {
      // console.log('willAgreementPrice')
      this.getPriceModelDeliveryInformation(nextProps.agreementPrice.PriceModelId)
      return
      // } else
      // if (!this.state.isShop && this.state.isAgreement && !isEqual(nextProps.selectedCustomerId, this.props.selectedCustomerId) && nextProps.selectedCustomerId > 0 && isEqual(this.props.agreementPrice.PriceModelId, nextProps.agreementPrice.PriceModelId)) {
      //   this.getCustomerAgreement(nextProps.agreementId, nextProps.selectedCustomerId)
    }
    if (this.state.isShop && this.state.isAgreement && !isEqual(nextProps.CustomerId, this.props.CustomerId)) {
      this.getDeliveryInformation(nextProps)
      return
      // this.getCustomerAgreement(nextProps.agreementId, nextProps.CustomerId)
    }
  }

  getPriceModelDeliveryInformation (priceModelId) {
    // console.log('getPriceModelDeliveryInformation ', priceModelId)
    this.props.getDeliveryInformation(0, 0, priceModelId).then((res) => {
      this.setDeliveryState(res)
    }, (err) => {
      console.log(err)
    })
  }

  getDeliveryInformation (nextProps) {
    let shopId = this.props.auth.user.ShopId
    let customerId = nextProps.CustomerId
    let priceModelId = nextProps.PriceModelId
    if (customerId === undefined) customerId = 0
    if (priceModelId === undefined) priceModelId = 0
    if (nextProps.isShop === true) {
      customerId = nextProps.item.CustomerId
      priceModelId = nextProps.item.PriceModelId
    }
    this.props.getDeliveryInformation(customerId, shopId, priceModelId).then((res) => {
      this.setDeliveryState(res)
    }, (err) => {
      console.log(err)
    })
  }
  setDeliveryState (res) {
    if (res.data.UseDefaultDelivery !== this.state.Delivery.UseDefaultDelivery && typeof this.props.onLayoutChange === 'function') {
      let colSpan = res.data.UseDefaultDelivery ? '1' : '3'
      this.props.onLayoutChange(colSpan)
    }
    this.setState({
      Delivery: res.data,
      NewItem: {
        Id: 0,
        PriceFrom: 0,
        PriceTo: 0,
        Hours: 1,
        PlusDriving: false,
        IsDeleted: false,
        ApplyType: 0
      },
      isLoaded: true
    }, () => {
      this.updateApplyType()
    })
  }
  updateDeliveryInformation (delivery) {
    this.setState({ isLoading: true })
    return this.props.saveDeliveryInformation(delivery).then((res) => {
      this.setState({ isLoading: false })
      this.setDeliveryState(res)
      // window.toastr.success(translation('1845'), translation('13424'))
      return res
    }, (err) => {
      // console.log('err', err.response.data)
      this.setState({ isLoading: false })
      if (err.response.data !== null) {
        let errorKey = err.response.data.DictionaryKey
        window.toastr.error(translation(errorKey), translation('216'))
      } else {
        window.toastr.error(translation('1846'), translation('216'))
      }
      return err
    })
  }
  getApplyType () {
    let type = 0
    let { price } = { ...this.state }
    // console.log('getApplyType: price', price, this.state)
    if (price !== undefined && price.PriceType !== undefined) {
      switch (price.PriceType) {
        case 1:
          type = 3
          break
        case 2:
          type = 7
          break
        case 3:
          type = 4
          break
        case 5:
          type = 2
          break
        default: break
      }
    }
    return type
  }
  updateApplyType () {
    this.setState({
      NewItem: {
        ...this.state.NewItem,
        ApplyType: this.getApplyType()
      }
    })
  }
  onBlur (e) {
    this.updateDeliveryInformation(this.state.Delivery)
  }

  getHours () {
    let hours = {
      1: '1 ' + translation('18103'),
      2: '2 ' + translation('542'),
      3: '3 ' + translation('542'),
      4: '4 ' + translation('542'),
      5: '5 ' + translation('542'),
      6: '6 ' + translation('542'),
      7: '7 ' + translation('542'),
      8: '8 ' + translation('542'),
      24: '24 ' + translation('542') + ' (1 ' + translation('18105') + ')',
      48: '48 ' + translation('542') + ' (2 ' + translation('18105') + ')',
      72: '72 ' + translation('542') + ' (3 ' + translation('18105') + ')',
      96: '96 ' + translation('542') + ' (4 ' + translation('18105') + ')',
      120: '120 ' + translation('542') + ' (5 ' + translation('18105') + ')',
      144: '144 ' + translation('542') + ' (6 ' + translation('18105') + ')',
      168: '168 ' + translation('542') + ' (7 ' + translation('18105') + ')',
      192: '192 ' + translation('542') + ' (8 ' + translation('18105') + ')',
      216: '216 ' + translation('542') + ' (9 ' + translation('18105') + ')',
      240: '240 ' + translation('542') + ' (10 ' + translation('18105') + ')',
      264: '264 ' + translation('542') + ' (11 ' + translation('18105') + ')',
      288: '288 ' + translation('542') + ' (12 ' + translation('18105') + ')'
    }
    return hours
  }

  getPriceType () {
    switch (this.state.Delivery.PriceType) {
      case 1:
        return translation('71')
      case 2:
        return translation('785')
      case 3:
        return translation('13361')
      case 5:
        return translation('13360')
      case 6:
        return translation('301')
      case 0:
        return translation('73')
      default: return undefined
    }
  }
  renderAgreement () {
    if (!this.state.isShop) return undefined
    let titletext = translation('196')
    if (this.state.Delivery.WorkProviderName !== undefined && this.state.Delivery.WorkProviderName !== null) {
      titletext += ' - ' + this.state.Delivery.WorkProviderName
    }

    return (
      <div>
        <PanelHeader text={titletext} />

        <Text name='PriceModelName' value={this.state.Delivery.PriceModelName} disabled labelText={translation('30')} />
        <Text name='OrderType' value={this.getPriceType()} disabled labelText={translation('69')} />

        {this.renderBrands()}
      </div>
    )
  }
  renderBrands () {
    let { price } = this.state
    const renderBrand = (val, key) => {
      return <Label key={key}>{val.BrandName}</Label>
    }

    return (
      <div>
        <PanelHeader text={translation('13473')} />

        {price.BrandSelectionType === 0 && (
          <Radio id='brands_all' name='BrandSelectionType' value='0' readOnly checked labelText={translation('381')} />
        )}
        {price.BrandSelectionType === 1 && (
          <div>
            {price.PriceModelBrands.map(renderBrand)}
          </div>
        )}
      </div>
    )
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    let isCustomer = this.props.type === 'customer'
    let isAgreement = !this.state.isShop && this.state.isAgreement
    let delivery = this.state.Delivery
    let hours = this.getHours()

    const cols = [ 0.75, 0.75, 2, 0.75, 1, 'min-content' ]
    const size = 'm'
    const renderDeliveryHourPrice = (item, key) => {
      let applyType = item.ApplyType === 0 ? '381' : enumtranslate('ApplyType', item.ApplyType)
      const deleteItem = () => {
        if (this.state.isShop) return
        let prices = { ...this.state.Delivery }
        prices.DeliveryHourPrices[key].IsDeleted = true
        this.updateDeliveryInformation(prices)
      }

      return (
        <TableRow cols={cols} key={key}>
          <div>{item.PriceFrom}</div>
          <div>{item.PriceTo}</div>
          <div>{hours[item.Hours]}</div>
          <Check value='0' checked={item.PlusDriving} disabled simple />
          <div>{translation(applyType)}</div>
          {!this.state.isShop && !this.state.Delivery.DeliveryFromParent && (
            <RemoveButton onClick={deleteItem} size={size} />
          )}
        </TableRow>
      )
    }

    const addItem = () => {
      let deliveryClone = JSON.parse(JSON.stringify(this.state.Delivery))
      let newItem = { ...this.state.NewItem }
      deliveryClone.DeliveryHourPrices.push(newItem)
      this.updateDeliveryInformation(deliveryClone)
    }

    const renderNewDeliveryHourPrice = () => {
      if (this.state.isShop || this.state.Delivery.DeliveryFromParent || !this.state.isLoaded) return undefined
      let price = this.state.NewItem
      // price.ApplyType = this.getApplyType()
      const onChange = (e) => {
        e.persist()
        let value = e.target.value
        if (e.target.type === 'checkbox') {
          value = e.target.checked
        }
        if (e.target.name === 'PriceFrom' || e.target.name === 'PriceTo') {
          value = parseInt(value)
          if (isNaN(value)) value = ''
        }

        this.setState({
          NewItem: {
            ...this.state.NewItem,
            [e.target.name]: value
          }
        }, () => {
          // console.log(e.target.name, value, this.state.NewItem)
        })
      }

      const onBlur = (e) => {
        e.persist()
        let value = e.target.value
        let name = e.target.name
        if (name === 'PriceFrom' || name === 'PriceTo') {
          if (value === '' || value === null) {
            value = 0
          }
        }
        this.setState({
          NewItem: {
            ...this.state.NewItem,
            [name]: value
          }
        })
      }

      let hours = this.getHours()
      let disabled = this.state.isMainAgreement || this.state.isAgreement
      return (
        <TableRow cols={cols}>
          <Text name='PriceFrom' value={price.PriceFrom} onChange={onChange} onBlur={onBlur} size={size} />
          <Text name='PriceTo' value={price.PriceTo} onChange={onChange} onBlur={onBlur} size={size} />

          <DropDown name='Hours' onChange={onChange} value={this.state.NewItem.Hours} disabled={this.state.Delivery.DeliveryFromParent} size={size}>
            { Object.keys(hours).map(key => {
              return <option value={key} key={'Hour_' + key}>{hours[key]}</option>
            })}
          </DropDown>

          <Check name='PlusDriving' value='1' checked={price.PlusDriving} onChange={onChange} disabled={this.state.Delivery.DeliveryFromParent} simple />

          <DropDown name='ApplyType' onChange={onChange} value={this.state.NewItem.ApplyType} disabled={disabled} size={size}>
            <option value='0'>{translation('381')}</option>
            <option value='1'>{translation(enumtranslate('ApplyType', 1))}</option>
            <option value='2'>{translation(enumtranslate('ApplyType', 2))}</option>
            <option value='3'>{translation(enumtranslate('ApplyType', 3))}</option>
            <option value='4'>{translation(enumtranslate('ApplyType', 4))}</option>
            <option value='7'>{translation(enumtranslate('ApplyType', 7))}</option>
            <option value='5'>{translation(enumtranslate('ApplyType', 5))}</option>
            <option value='6'>{translation(enumtranslate('ApplyType', 6))}</option>
          </DropDown>

          <AddButton onClick={addItem} size={size} disabled={this.state.isLoading} />
        </TableRow>
      )
    }
    let Delivery = { ...this.state.Delivery }

    const onChange = (e) => {
      e.persist()
      let value = e.target.value
      if (e.target.type === 'checkbox') {
        value = e.target.checked
      } else if (e.target.type === 'select-one') {
        value = parseInt(value)
      }
      this.setState({
        Delivery: {
          ...this.state.Delivery,
          [e.target.name]: value
        }
      }, () => {
        if (e.target.name === 'UseDefaultDelivery' && typeof this.props.onLayoutChange === 'function') {
          let colSpan = this.state.Delivery.UseDefaultDelivery ? '1' : '3'
          this.props.onLayoutChange(colSpan)
        }
        if (e.target.type === 'checkbox' || e.target.type === 'radio' || e.target.type === 'select-one' || e.target.type === 'DeliveryFromParent') {
          this.onBlur(e)
        }
      })
    }

    const renderContent = () => {
      let hours = this.getHours()
      return (
        <Panel title={translation('196')}>
          {/* Agreement should come first above title */}
          {this.renderAgreement()}

          {isAgreement && (
            <Check name='DeliveryFromParent' value='1' checked={delivery.DeliveryFromParent} onChange={onChange} disabled={!this.state.isLoaded} labelText={translation('1921')} helpText={translation('1950')} />
          )}

          {isCustomer && (
            <div>
              <Check name='AllowChangeDelivery' value='1' checked={delivery.AllowChangeDelivery} onChange={onChange} labelText={translation('1622')} helpText={translation('1948')} />

              {hasSubscriptionPermission(this.props.auth, 20) && (
                <Check name='UseDefaultDelivery' value='1' checked={delivery.UseDefaultDelivery} onChange={onChange} labelText={translation('1921')} helpText={translation('1950')} />
              )}
            </div>
          )}

          {hasSubscriptionPermission(this.props.auth, 20) && (!isCustomer || !delivery.UseDefaultDelivery) && (
            <div>
              <LabelWrapper labelText={translation('1531')} helpText={translation('1951')}>
                <Inline fillChildNum={[0]} block>
                  <DropDown
                    name='DefaultHours'
                    onChange={onChange}
                    value={delivery.DefaultHours + '' || ''}
                    disabled={this.state.isShop || this.state.Delivery.DeliveryFromParent || !this.state.isLoaded}
                  >
                    { Object.keys(hours).map(key => {
                      console.log('newHours[key]', hours[key])
                      console.log('key', key)
                      return <option value={key} key={'DefaultHours_' + key}>{hours[key]}</option>
                    })}
                  </DropDown>
                  <Check
                    name='DeliveryPlusDriving'
                    value='1'
                    checked={delivery.DeliveryPlusDriving}
                    onChange={onChange}
                    disabled={this.state.isShop || this.state.Delivery.DeliveryFromParent || !this.state.isLoaded}
                    labelText={translation('1527')}
                  />
                </Inline>
              </LabelWrapper>

              <div>
                <TableRow header cols={cols.fill('32px', cols.length - 1)}>
                  <div>{translation('1529')}</div>
                  <div>{translation('1530')}</div>
                  <div>{translation('15370')}</div>
                  <div>{translation('1527')}</div>
                  <div>{translation('18104')}</div>
                  <HelpIcon helpText={translation('1952')} />
                </TableRow>

                {renderNewDeliveryHourPrice()}
                {Delivery.DeliveryHourPrices.map(renderDeliveryHourPrice)}
              </div>
            </div>
          )}
        </Panel>
      )
    }

    if (this.props.type === 'shop') {
      return (
        <div className='deliveryhour__page'>
          <Col span='6'>
            {renderContent()}
          </Col>
        </div>
      )
    }

    return renderContent()
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getDeliveryInformation,
  saveDeliveryInformation,
  getShopCustomerAgreement,
  getPriceList
})(Delivery)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Delivery/index.js